import { db } from "@/firebase";
import {
  getDocs,
  collection,
  getDoc,
  doc,
  query,
  where,
  updateDoc,
  collectionGroup,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

const admin = {
  state: {
    calendar: [],
    notifications: [],
    users: [],
    workspaces: [],
    backlog: [],
    emails: [],
    articles: [],
    stats: [],
    prompts: null,
    waitingList: [],
    supportTickets: [],
  },
  mutations: {
    setAdminUsers(state, val) {
      state.users = val;
    },
    setAdminWorkspaces(state, val) {
      state.workspaces = val;
    },
    setAdminNotifications(state, val) {
      state.notifications = val;
    },
    setAdminCalendar(state, val) {
      state.calendar = val;
    },
    setAdminBacklog(state, val) {
      state.backlog = val;
    },
    setAdminEmails(state, val) {
      state.emails = val;
    },
    setAdminArticles(state, val) {
      state.articles = val;
    },
    removeAdminUser(state, val) {
      let i = state.users.findIndex((u) => u.uid === val);
      state.users.splice(i, 1);
    },
    setAdminStats(state, val) {
      state.stats = val;
    },
    setAdminPrompts(state, val) {
      state.prompts = val;
    },
    setAdminWaitingList(state, val) {
      state.waitingList = val;
    },
    setAdminSupportTickets(state, val) {
      state.supportTickets = val;
    },
    updateBacklogOrder(state, { state: stateName, items }) {
      state.backlog[stateName] = items;
    },
  },
  actions: {
    async fetchAdminSupportTickets({ commit }) {
      // Use collectionGroup to get all "tickets" subcollections across all user documents
      const tickets = query(collectionGroup(db, "tickets"));
      const querySnapshot = await getDocs(tickets);
      querySnapshot.forEach((doc) => {
        console.log(doc.id, " => ", doc.data());
      });
      let supportTickets = [];
      await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          let t = doc.data();
          t.messages = [];
          const messages = await getDocs(
            collection(
              db,
              "users",
              doc.data().user,
              "tickets",
              doc.id,
              "messages"
            )
          );
          messages.docs.map((m) => {
            t.messages.push(m.data());
          });
          t.messages.sort((a, b) => b.created_at - a.created_at);
          supportTickets.push(t);
        })
      );
      console.log("supportTickets", supportTickets);
      supportTickets.sort((a, b) => b.created_at - a.created_at);
      commit("setAdminSupportTickets", supportTickets);
    },
    async fetchAdmin({ dispatch }) {
      await dispatch("fetchAdminUsers");
      await dispatch("fetchAdminWorkspaces");
      await dispatch("fetchAdminNotifications");
      await dispatch("fetchAdminCalendar");
      await dispatch("fetchAdminBacklog");
      await dispatch("fetchAdminEmails");
      await dispatch("fetchAdminStats");
      await dispatch("fetchAdminPrompts");
      await dispatch("fetchAdminWaitingList");
      await dispatch("fetchAdminSupportTickets");
    },
    async clearDoneState({ dispatch }) {
      const q = query(collection(db, "backlog"), where("status", "==", "done"));

      const querySnapshot = await getDocs(q);
      await Promise.all(
        querySnapshot.docs.map(async (d) => {
          await updateDoc(doc(db, "backlog", d.id), {
            status: "closed",
          });
        })
      );

      dispatch("fetchAdminBacklog");
    },
    async fetchAdminWaitingList({ commit }) {
      const q = query(collection(db, "waiting_list"));
      const querySnapshot = await getDocs(q);
      let waitingList = [];
      querySnapshot.docs.map((doc) => {
        waitingList.push(doc.data());
      });
      waitingList.sort((a, b) =>
        a.created_at < b.created_at ? 1 : b.created_at < a.created_at ? -1 : 0
      );
      commit("setAdminWaitingList", waitingList);
    },
    async fetchAdminPrompts({ commit }) {
      const docSnap = await getDoc(doc(db, "admin", "prompts"));
      commit("setAdminPrompts", docSnap.data());
    },
    async deleteAdminUser({ commit }, val) {
      const adminRemoveUser = httpsCallable(functions, "adminRemoveUser");
      const res = await adminRemoveUser({ uid: val });
      console.log(res);
      commit("removeAdminUser", val);
    },
    async fetchAdminStats({ commit }) {
      let stats = [];
      const querySnapshot = await getDocs(collection(db, "stats"));
      querySnapshot.docs.map((doc) => {
        stats.push(doc.data());
      });
      commit("setAdminStats", stats);
    },
    async fetchAdminUsers({ commit }) {
      commit("setLoading", { type: "admin.users", val: true });
      let users = [];

      const querySnapshot = await getDocs(collection(db, "users"));

      await Promise.all(
        querySnapshot.docs.map(async (d) => {
          let user = d.data();
          let workspace_names = [];
          for (let x in user.workspaces) {
            const docSnap = await getDoc(
              doc(db, "workspaces", user.workspaces[x])
            );
            if (docSnap.exists()) {
              workspace_names.push(docSnap.data());
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
          }
          user.workspaces = workspace_names;
          users.push(user);
        })
      );

      users.sort((a, b) =>
        a.joined < b.joined ? 1 : b.joined < a.joined ? -1 : 0
      );

      commit("setAdminUsers", users);
      commit("setLoading", { type: "admin.users", val: false });
    },
    async fetchAdminWorkspaces({ commit }) {
      commit("setLoading", { type: "admin.workspaces", val: true });
      let workspaces = [];

      const querySnapshot = await getDocs(collection(db, "workspaces"));

      querySnapshot.docs.map(async (d) => {
        let workspace = d.data();
        workspaces.push(workspace);
      });

      workspaces.sort((a, b) =>
        a.created_at < b.created_at ? 1 : b.created_at < a.created_at ? -1 : 0
      );

      commit("setAdminWorkspaces", workspaces);
      commit("setLoading", { type: "admin.workspaces", val: false });
    },
    async fetchAdminArticles({ commit }) {
      commit("setLoading", { type: "admin.articles", val: true });
      const a = httpsCallable(functions, "websiteArticlesGet");
      const articles = await a();
      commit("setAdminArticles", articles.data);
      commit("setLoading", { type: "admin.articles", val: false });
    },
    async fetchAdminNotifications({ commit }) {
      commit("setLoading", { type: "admin.notifications", val: true });
      let notifications = [];

      const querySnapshot = await getDocs(collection(db, "notifications"));

      querySnapshot.docs.map(async (d) => {
        let workspace = d.data();
        notifications.push(workspace);
      });

      notifications.sort((a, b) =>
        a.created_at < b.created_at ? 1 : b.created_at < a.created_at ? -1 : 0
      );

      commit("setAdminNotifications", notifications);
      commit("setLoading", { type: "admin.notifications", val: false });
    },
    async fetchAdminBacklog({ commit }) {
      commit("setLoading", { type: "admin.backlog", val: true });

      let backlog = [
        {
          id: 0,
          name: "requested",
          items: [],
        },
        {
          id: 1,
          name: "backlog",
          items: [],
        },
        {
          id: 2,
          name: "in_development",
          items: [],
        },
        {
          id: 3,
          name: "ready_for_review",
          items: [],
        },
        {
          id: 4,
          name: "done",
          items: [],
        },
      ];

      const q = query(
        collection(db, "backlog"),
        where("status", "!=", "closed")
      );
      const querySnapshot = await getDocs(q);

      querySnapshot.docs.map(async (d) => {
        let state = d.data().status.replaceAll(" ", "_");
        let index = backlog.findIndex((b) => b.name === state);

        let item = d.data();
        if (item.suggested_by) {
          let user = await getDoc(doc(db, "users", item.suggested_by));
          if (user.exists()) {
            item.suggested_by_name =
              user.data().first_name || "" + " " + user.data().last_name || "";
            item.suggested_by_email = user.data().email || "";
          }
        }

        backlog[index].items.push(item);
      });

      backlog.forEach((b) => {
        b.items.sort((a, b) => {
          return a.order - b.order;
        });
      });

      commit("setAdminBacklog", backlog);
      commit("setLoading", { type: "admin.backlog", val: false });
    },
    async fetchAdminEmails({ commit }) {
      commit("setLoading", { type: "admin.emails", val: true });
      let emails = [];

      const querySnapshot = await getDocs(collection(db, "mail"));

      querySnapshot.docs.map(async (d) => {
        let e = d.data();
        e.uid = d.id;
        emails.push(e);
      });

      emails.sort((a, b) => {
        const timeA = a?.delivery?.endTime || 0;
        const timeB = b?.delivery?.endTime || 0;

        if (timeA > timeB) return -1;
        if (timeA < timeB) return 1;
        return 0;
      });
      commit("setAdminEmails", emails);
      commit("setLoading", { type: "admin.emails", val: false });
    },
    async fetchAdminCalendar({ commit }) {
      commit("setLoading", { type: "admin.calendar", val: true });
      let calendar = [];

      const querySnapshot = await getDocs(collection(db, "calendar"));

      querySnapshot.docs.map(async (d) => {
        calendar.push(d.data());
      });

      calendar.sort((a, b) => (a.unix < b.unix ? -1 : b.unix < a.unix ? 1 : 0));

      commit("setAdminCalendar", calendar);
      commit("setLoading", { type: "admin.calendar", val: false });
    },

    async updateBacklog({ commit, state }, v) {
      commit("setLoading", { type: "admin.backlog", val: true });
      let backlog = state.backlog;
      console.log(v);
      let index = null;
      if (v.event.moved) {
        index = backlog[backlog.findIndex((b) => b.name === v.state)].findIndex(
          (i) => i.uid === v.event.moved.element.uid
        );
        console.log(index);
      } else if (v.event.removed) {
        index = backlog[backlog.findIndex((b) => b.name === v.state)].findIndex(
          (i) => i.uid === v.event.removed.element.uid
        );
        backlog[backlog.findIndex((b) => b.name === v.state)].splice(index, 1);
      } else if (v.event.added) {
        let el = v.event.added.element;
        el.status = v.state.replaceAll("_", " ");
        backlog[backlog.findIndex((b) => b.name === v.state)].push(el);
      }

      await Promise.all(
        backlog[backlog.findIndex((b) => b.name === v.state)].map(
          async (item) => {
            await updateDoc(doc(db, "backlog", item.uid), {
              ...item,
            });
          }
        )
      );

      commit("setAdminBacklog", backlog);
      commit("setLoading", { type: "admin.backlog", val: false });
    },
    async updateBacklogOrder({ state }) {
      await Promise.all(
        state.backlog.map(async (b) => {
          await Promise.all(
            b.items.map(async (i, index) => {
              await updateDoc(doc(db, "backlog", i.uid), {
                order: index,
                status: b.name.replace("_", " "),
              });
            })
          );
        })
      );
    },
  },
  getters: {},
};

export default admin;
